<template>
  <div class='container-fluid'>
    <div class='cardlist-header mt-5'>
      <div class='row'>
        <div class='col'>
          <h2>{{ title }}</h2>
        </div>

        <div class='col'>
          <div class='text-right'>
            <base-button @click='addStudioModal = true'
                         icon='ni ni-fat-add' type='default'
                         v-if='!this.$route.query.studioId && !this.$route.query.customerId'></base-button>
            <base-button @click='addCustomerModal = true' icon='ni ni-fat-add' type='default'
                         v-if='this.$route.query.studioId'></base-button>
            <base-button @click='addProjectModal = true' icon='ni ni-fat-add' type='default'
                         v-if='this.$route.query.customerId'></base-button>
            <base-button outline type='primary' v-if='this.$route.query.customerId && this.$route.query.billed === true' @click="showProjects">Projekte</base-button>
            <base-button outline type='primary' v-if='this.$route.query.customerId && !this.$route.query.billed === true' @click="showBilledProjects">Abgerechnete Projekte</base-button>
          </div>
        </div>
      </div>
    </div>

    <div class='row mt-3' v-if='!this.$route.query.studioId && !this.$route.query.customerId'>

      <div @click='selectItem(0, item.id)' class='col-lg-4 mb-5' v-bind:key='index'
           v-for='(item, index) in this.studios'>
        <StudiosListItem :item='item'></StudiosListItem>
      </div>

    </div>

    <div class="row mt-3" v-if='!this.$route.query.studioId && !this.$route.query.customerId'>
      <div @click='selectItem(0, item.id)' class='col-lg-4 mb-5' v-bind:key='index'
           v-for='(item, index) in this.privateStudios'>
        <PrivateStudioListItem :item='item'></PrivateStudioListItem>
      </div>
    </div>

    <div class='row mt-3' v-if='this.$route.query.studioId'>

      <div @click='selectItem(1, item.id)' class='col-lg-4 mb-5' v-bind:key='index'
           v-for='(item, index) in this.customers'>
        <CustomersListItem :item='item'></CustomersListItem>
      </div>

    </div>

    <div class='row mt-3' v-if='this.$route.query.customerId && !this.$route.query.billed === true'>

      <div @click='selectProject(item.id)' class='col-lg-4 mb-5' v-bind:key='index'
           v-for='(item, index) in this.projects'>
        <ProjectsListItem :item='item'></ProjectsListItem>
      </div>

    </div>

    <div class='row mt-3' v-if='this.$route.query.customerId && this.$route.query.billed === true'>

      <div @click='selectProject(item.id)' class='col-lg-4 mb-5' v-bind:key='index'
           v-for='(item, index) in this.billedProjects'>
        <BilledProjectsListItem :item='item'></BilledProjectsListItem>
      </div>

    </div>

    <modal :show.sync='addStudioModal'
           body-classes='p-0'
           modal-classes='modal-dialog-centered modal-sm'>
      <card body-classes='px-lg-5 py-lg-5' class='border-0'
            header-classes='bg-white pb-5'
            shadow
            type='secondary'>
        <template>
          <div class='text-muted text-center mb-3'>
            <small>Tonstudio hinzufügen</small>
          </div>
        </template>
        <template>
          <form role='form'>
            <base-input addon-left-icon='ni ni-single-02'
                        alternative
                        class='mb-3'
                        placeholder='Studioname' v-model='addStudioForm.name'>
            </base-input>

            <base-checkbox class='mb-3' v-model='addStudioForm.private'>
              Privates Studio
            </base-checkbox>

            <div class='text-center'>
              <base-button @click='addNewStudio' type='primary'>Hinzufügen</base-button>
            </div>
          </form>
        </template>
      </card>
    </modal>

    <modal :show.sync='addCustomerModal'
           body-classes='p-0'
           modal-classes='modal-dialog-centered modal-sm'>
      <card body-classes='px-lg-5 py-lg-5' class='border-0'
            header-classes='bg-white pb-5'
            shadow
            type='secondary'>
        <template>
          <div class='text-muted text-center mb-3'>
            <small>Kunden hinzufügen</small>
            <div>
              <small style="color: red;">{{ this.addCustomerForm.error_msg }}</small>
            </div>
          </div>
        </template>
        <template>
          <form role='form'>
            <base-input addon-left-icon='ni ni-single-02'
                        alternative
                        class='mb-3'
                        placeholder='Kundenname' v-model='addCustomerForm.name'>
            </base-input>

            <base-input addon-left-icon='ni ni-single-02'
                        alternative
                        class='mb-3'
                        min="0"
                        placeholder='Stundenlohn'
                        type="number" v-model='addCustomerForm.hourly_rate'></base-input>

            <div class='text-center'>
              <base-button @click='addNewCustomer' type='primary'>Hinzufügen</base-button>
            </div>
          </form>
        </template>
      </card>
    </modal>

    <modal :show.sync='addProjectModal'
           body-classes='p-0'
           modal-classes='modal-dialog-centered modal-sm'>
      <card body-classes='px-lg-5 py-lg-5' class='border-0'
            header-classes='bg-white pb-5'
            shadow
            type='secondary'>
        <template>
          <div class='text-muted text-center mb-3'>
            <small>Projekt hinzufügen</small>
          </div>
        </template>
        <template>
          <form role='form'>
            <base-input addon-left-icon='ni ni-single-02'
                        alternative
                        class='mb-3'
                        placeholder='Projektname' v-model='addProjectForm.title'>
            </base-input>

            <base-input addon-left-icon='ni ni-align-left-2'
                        alternative
                        class='mb-3'
                        placeholder='Beschreibung' v-model='addProjectForm.desc'>
            </base-input>

            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-picker :config="{allowInput: true, dateFormat: 'd.m.Y'}"
                           @on-close="blur"
                           @on-open="focus"
                           class="form-control datepicker"
                           slot-scope="{focus, blur}"
                           v-model="addProjectForm.date">
              </flat-picker>
            </base-input>

            <div class='text-center'>
              <base-button @click='addNewProject' type='primary'>Hinzufügen</base-button>
            </div>

            <p>{{ this.addProjectForm }}</p>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>

<script>
  import firebase from 'firebase/app';
  import 'firebase/firestore';
  import StudiosListItem from './StudiosListItem';
  import PrivateStudioListItem from './PrivateStudioListItem';
  import CustomersListItem from './CustomersListItem';
  import ProjectsListItem from './ProjectsListItem';
  import BilledProjectsListItem from './BilledProjectsListItem';
  import { mapState } from 'vuex';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import * as moment from 'moment';

  export default {
    name: 'CardList',
    components: {
      StudiosListItem,
      PrivateStudioListItem,
      CustomersListItem,
      ProjectsListItem,
      BilledProjectsListItem,
      flatPicker
    },
    data() {
      return {
        title: 'Studios',
        studios: [],
        privateStudios: [],
        customers: [],
        projects: [],
        billedProjects: [],
        level: 0,
        addStudioModal: false,
        addStudioForm: {
          name: '',
          private: false
        },
        addCustomerModal: false,
        addCustomerForm: {
          name: '',
          hourly_rate: 0,
          error_msg: ''
        },
        addProjectModal: false,
        addProjectForm: {
          title: '',
          desc: '',
          hourly_rate: 0,
          hours: 0,
          billed: false,
          date: moment().format('DD.MM.YYYY'),
          customer: this.$route.query.customerId
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
      })
    },
    methods: {
      // Redirect on Studio/Customer/Project selection
      selectProject(id) {
        this.$router.push({ name: 'project', query: { projectId: id } });
      },
      selectItem(level, id) {
        switch (level) {
          case 0:
            this.$router.push({ name: 'dashboard', query: { studioId: id } });
            break;
          case 1:
            this.$router.push({ name: 'dashboard', query: { customerId: id } });
            break;
        }
      },
      showBilledProjects() {
        this.$router.push({ name: 'dashboard', query: { customerId: this.$route.query.customerId, billed: true } });
      },

      showProjects() {
        this.$router.push({ name: 'dashboard', query: { customerId: this.$route.query.customerId } });
      },

      // Get all Studios
      getStudios() {
        let itemId = '';
        let itemName = '';

        firebase.firestore().collection('studios').where('is_private', '==', false).onSnapshot((querySnapshot) => {
          this.studios = [];
          querySnapshot.forEach((doc) => {
            itemId = doc.id;
            itemName = doc.data().name;

            let item = {
              id: itemId,
              name: itemName,
              hours: 0,
              profit: 0,
              verified: doc.data().verified,
              verification_key: doc.data().verification_key
            };

            this.studios.push(item)
          });
        });
      },
      getPrivateStudios() {
        firebase.firestore().collection('studios').where('is_private', '==', true).onSnapshot((querySnapshot) => {
          this.privateStudios = [];
          querySnapshot.forEach((doc) => {
            let item = {
              id: doc.id,
              name: doc.data().name,
              hours: 0,
              profit: 0,
              verified: doc.data().verified,
              verification_key: doc.data().verification_key
            };

            this.privateStudios.push(item)
          });
        });
      },
      // Get customers with 'studio_id'
      getCustomers() {
        let itemId = '';
        let itemName = '';

        firebase.firestore().collection('customers').where("studio_id", "==", this.$route.query.studioId).onSnapshot((querySnapshot) => {
          this.customers = [];
          querySnapshot.forEach((doc) => {
            itemId = doc.id;
            itemName = doc.data().name;

            let item = {
              id: itemId,
              name: itemName,
              hourly_rate: doc.data().hourly_rate,
              created_at: doc.data().created_at,
              profit: 0,
              hours: 0
            };

            this.customers.push(item)
          });
        });
      },

      getProjects() {
        firebase.firestore().collection("projects").where('customer', '==', this.$route.query.customerId).where('billed', '==', false)
          .onSnapshot((querySnapshot) => {
            this.projects = [];
            let itemName = '';
            let itemId = '';

            querySnapshot.forEach((doc) => {
              itemId = doc.id;
              itemName = doc.data().title;

              let item = {
                id: itemId,
                name: itemName,
                billed: doc.data().billed,
                date: doc.data().date,
                desc: doc.data().desc,
                hours: doc.data().hours,
              };

              this.projects.push(item)
            });
          });
      },

      getBilledProjects() {
        firebase.firestore().collection("projects").where('customer', '==', this.$route.query.customerId).where('billed', '==', true)
          .onSnapshot((querySnapshot) => {
            this.billedProjects = [];
            let itemName = '';
            let itemId = '';

            querySnapshot.forEach((doc) => {
              itemId = doc.id;
              itemName = doc.data().title;

              let item = {
                id: itemId,
                name: itemName,
                billed: doc.data().billed,
                date: doc.data().date,
                desc: doc.data().desc,
                hours: doc.data().hours,
              };

              this.billedProjects.push(item)
            });
          });
      },

      checkCurrentRoute() {
        // Check the current Route and load Data
        if (this.$route.query.studioId) {
          if (this.$route.query.studioId !== '') {
            this.title = 'Kunden';
            this.getCustomers();
          }
        } else if (this.$route.query.customerId) {
          if (this.$route.query.customerId !== '' && !this.$route.query.billed) {
            this.title = 'Projekte';
            this.getProjects();
          } else if (this.$route.query.customerId !== '' && this.$route.query.billed) {
            this.title = 'Abgerechnete Projekte';
            this.getBilledProjects();
          }
        } else {
          if (this.user.is_admin === false) {
            // Get User Studio and redirect
            firebase.firestore().collection('studios').where('user_id', '==', this.user.uid).onSnapshot((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                this.$router.push({ name: 'dashboard', query: { studioId: doc.id } });
              });
            });
          } else if (this.user.is_admin === true) {
            // Get all Studio
            this.title = 'Studios';
            this.getStudios();
            this.getPrivateStudios();
          }
        }
      },
      addNewStudio() {
        if (this.addStudioForm.private) {
          firebase.firestore().collection('studios').add({
            name: this.addStudioForm.name,
            user_id: this.user.uid,
            is_private: true,
            created_at: new Date()
          })
            .then(() => {
              this.addStudioModal = false
            })
            .catch(function (error) {
              // eslint-disable-next-line no-console
              console.error('Error writing document: ', error);
            });
        } else {
          // Add Studio
          let verification_key = this.$uuid.v4();

          firebase.firestore().collection('studios').add({
            name: this.addStudioForm.name,
            user_id: '',
            verification_key: verification_key,
            verified: false,
            is_private: false,
            created_at: new Date(),
          })
            .then(() => {
            })
            .catch(function (error) {
              // eslint-disable-next-line no-console
              console.error('Error writing document: ', error);
            });
        }
      },
      addNewCustomer() {
        if (this.addCustomerForm.name.length >= 3) {
          firebase.firestore().collection('customers').add({
            name: this.addCustomerForm.name,
            studio_id: this.$route.query.studioId,
            hourly_rate: this.addCustomerForm.hourly_rate,
            user_id: this.user.uid,
            created_at: new Date(),
          })
            .then(() => {
              this.addCustomerModal = false
            })
            .catch(function (error) {
              // eslint-disable-next-line no-console
              console.error('Error writing document: ', error);
            });
        } else {
          this.addCustomerForm.error_msg = 'Bitte gib einen Namen an!'
        }
      },
      addNewProject() {
        if (this.addProjectForm.title.length >= 3) {

          const docRef = firebase.firestore().collection("customers").doc(this.$route.query.customerId);

          docRef.get().then((doc) => {
            if (doc.exists) {
              firebase.firestore().collection('projects').add({
                title: this.addProjectForm.title,
                desc: this.addProjectForm.desc,
                date: this.addProjectForm.date,
                customer: this.$route.query.customerId,
                billed: false,
                hourly_rate: doc.data().hourly_rate,
                hours: 0,
              })
                .then(() => {
                  this.addProjectModal = false
                })
                .catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.error('Error writing document: ', error);
                });
            } else {
              // doc.data() will be undefined in this case
              // eslint-disable-next-line no-console
              console.log("No such document!");
            }
          }).catch(function (error) {
            // eslint-disable-next-line no-console
            console.log("Error getting document:", error);
          });
        } else {
          this.addCustomerForm.error_msg = 'Bitte gib einen Namen an!'
        }
      }
    },
    watch: {
      $route() {
        this.checkCurrentRoute();
      }
    },
    created() {
      this.checkCurrentRoute();
      if (this.user.isAdmin) {
        this.level = 0
      } else {
        this.level = 1
      }
    }
  }
</script>

<style scoped>
  .cardlist-header > h2 {
    margin: 0;
    text-transform: uppercase;
  }
</style>
